module.exports = __webpack_public_path__ + "img/LDOGE.8b2026b3.svg";